import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  padding: 2rem 0;
  background: ${({ theme }) => theme.colors.background};
  min-height: 100vh;

  .contentButton {
    width: 85%;
    display: flex;
    justify-content: flex-end;
  }
`;
